// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.topRight[data-v-4da4bba5] {\r\n  float: right;\n}\n.editLgIconAdjustment[data-v-4da4bba5] {\r\n  margin-left: 22px;\n}\n.accountItem[data-v-4da4bba5]:hover {\r\n  background-color: #ffc69d;\n}\n.statusText[data-v-4da4bba5] {\r\n  display: inline !important;\r\n  text-transform: capitalize !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
